export class PgfnVO {

  situacaoDescricao: string;

}
